import { ProductPayType } from "../../../../../services/PayTypesServices.dto";

export const filterStringProperties = (productos: ProductPayType[]): { [key: string]: string }[] => {
    return productos.map(producto => {
      const nuevoProducto: { [key: string]: string } = {};
  
      for (const clave in producto) {
        if (typeof producto[clave] === 'string') {
          nuevoProducto[clave] = producto[clave] as string;
        }
      }
  
      return nuevoProducto;
    });
  };
  